<template>
  <v-col cols="12" class="px-0">
    <v-list class="py-0 failures-list" dense>
      <v-list-item
        v-for="failure in fullListVisible ? filteredFailures : filteredFailures.slice(0, 10)"
        :key="failure.id"
        @click="emitFailureToOpen(failure.id)"
        class="failure-element hover-list-element px-2"
      >
        <v-list-item-content>
          <v-list-item-title class="text-body-2">
            <v-row no-gutters class="flex-nowrap">
              <v-col cols="auto" style="max-width: 80%">
                <v-tooltip bottom color="font" max-width="300">
                  <template #activator="{ on }">
                    <div class="text-body-2 failures-list-text" v-on="on">
                      {{ failure.name }}
                    </div>
                  </template>
                  <div style="word-break: break-all;">
                    {{ failure.name }}
                  </div>
                </v-tooltip>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" style="max-width: 20%">
                <v-tooltip bottom color="font">
                  <template #activator="{ on }">
                    <v-chip :color="computedColors[failure.status]" small v-on="on" style="height: 20px">
                      <div class="white--text failures-list-text">
                        {{ failure.status }}
                      </div>
                    </v-chip>
                  </template>
                  <div style="word-break: break-all;">
                    {{ failure.status }}
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <list-toggler v-if="filteredFailures.length > 10" v-model="fullListVisible" />
    </v-list>
  </v-col>
</template>
<script>
import { get } from 'vuex-pathify';
import ListToggler from '@/components/ListToggler';

export default {
  name: 'FailuresList',
  components: {
    ListToggler,
  },
  props: {
    failures: {
      type: Object,
      required: true,
    },
  },
  computed: {
    failuresStatuses: get('admin/modulesMapping@failures.statuses'),
    colors() {
      return {
        new: 'rgba(191,54,12)',
        completed: 'rgba(24,128,56)',
        active: 'rgba(255,136,0)',
        planned: 'rgba(108,108,108)',
        unrealized: 'rgba(191,54,12)',
      };
    },
    computedColors() {
      const computedColors = {};
      for (const statusKey in this.failuresStatuses) {
        const statusText = this.failuresStatuses[statusKey];
        const statusColor = this.colors[statusKey];
        computedColors[statusText] = statusColor;
      }
      return computedColors;
    },
    failuresStatusesActive() {
      const activeFailureStatuses = [];
      for (const status in this.failuresStatuses) {
        if (['active', 'new'].includes(status)) {
          activeFailureStatuses.push(this.failuresStatuses[status]);
        }
      }
      return activeFailureStatuses;
    },
    filteredFailures() {
      return this.$_objectToArray(this.failures).filter(failure =>
        this.failuresStatusesActive.includes(failure.status)
      );
    },
  },
  data: () => ({
    fullListVisible: false,
  }),
  methods: {
    emitFailureToOpen(id) {
      this.$router.push({
        name: 'failure',
        params: { fid: id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.failure-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.failures-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.failures-list-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
